import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

export const DefaultThresholdIcon = (props: Partial<CustomIconComponentProps>) => {
  const DefaultThresholdSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='48'
        height='48'
        viewBox='0 0 48 48'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M42 37.24C42 37.7 41.7 38.06 41.28 38.2L30 42L18 37.8L7.32 41.94L7 42C6.44 42 6 41.56 6 41V10.76C6 10.3 6.3 9.94 6.72 9.8L18 6L30 10.2L40.68 6.06L41 6C41.56 6 42 6.44 42 7V37.24ZM38 35.0841L30.0248 37.7708L17.9294 33.5374L10 36.6111V12.9159L17.9752 10.2292L30.0706 14.4626L38 11.3889V35.0841Z'
          fill='#696F88'
        />
        <path
          d='M16.0043 17.0234C16.0085 17.1143 16.0166 17.2424 16.0326 17.3997C16.0643 17.7134 16.1276 18.1484 16.2546 18.6391C16.5037 19.6012 17.0214 20.8711 18.1326 21.8246C19.2598 22.7917 20.6475 23.1363 21.6979 23.2487C21.9934 23.2803 22.2679 23.2943 22.5106 23.298V32H24.3708V28.5257C24.5824 28.5358 24.8175 28.5425 25.0686 28.5424C26.0463 28.5422 27.3833 28.441 28.5079 27.9572C29.6871 27.45 30.4983 26.484 30.9911 25.7448C31.2465 25.3618 31.437 25.008 31.564 24.7495C31.6277 24.6198 31.6762 24.5127 31.7093 24.4364C31.7093 24.4364 31.8043 24.2587 32 23.6986C31.7093 23.5018 31.206 23.2963 31.206 23.2963C31.1195 23.2577 30.9986 23.2069 30.8481 23.1516C30.5483 23.0413 30.1227 22.9099 29.6105 22.822C28.5841 22.6459 27.1688 22.6401 25.7524 23.3693C25.2061 23.6505 24.7503 23.9855 24.3708 24.3395L24.3717 22.4515C24.3727 22.4263 24.3738 22.391 24.3745 22.3466C24.3761 22.2578 24.3762 22.1322 24.3712 21.9776C24.3612 21.6693 24.3304 21.2404 24.2467 20.7539C24.0832 19.8029 23.7015 18.5317 22.7715 17.5354C21.7509 16.4419 20.1476 16.1203 18.9869 16.0315C18.3837 15.9854 17.8395 15.9973 17.4472 16.0203C17.25 16.0319 17.0885 16.0464 16.9739 16.0584C16.9739 16.0584 16.9084 16.0584 16 16.1912C16.0001 16.8366 16.0043 17.0234 16.0043 17.0234Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={DefaultThresholdSVG} {...props} />;
};

export const CustomThresholdIcon = (props: Partial<CustomIconComponentProps>) => {
  const CustomThresholdSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='48'
        height='48'
        viewBox='0 0 48 48'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10 6H14V10L34 10V6H38V10L42 10V14H38V34H42V38H38V42H34V38L14 38V42H10V38H6V34H10V14H6V10L10 10V6ZM14 34V14L34 14V34L14 34Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={CustomThresholdSVG} {...props} />;
};

export const EqualsIcon = (props: Partial<CustomIconComponentProps>) => {
  const EqualsSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4 9H20V11H4V9ZM20 15H4V13H20V15Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={EqualsSVG} {...props} />;
};
